import Button from '../../../components/Button'
import SearchField from '../../../components/SearchField'
import useSubmit from '../useSubmit'
import { controlList } from '../storage'
import Rules from '../../../components/Rules'
import {
    FlexBox,
    FlexLeft,
    FlexRight,
    SectionFiltersGrid
} from '../../../components/UtilsResponsive/UtilsResponsive.style'

export default function SearchCategories() {
    const { props } = controlList.useSearch()
    const open = useSubmit()
    return (
        <SectionFiltersGrid>
            <SearchField
                {...props}
                placeholder="Buscar por código o nombre de la categoría"
                size="auto"
                fullWidth={true}
            />
            <FlexBox>
                <FlexLeft></FlexLeft>
                <FlexRight>
                    <Rules cu="CU042">
                        <Button size="sm" onClick={() => open()}>
                            Nuevo
                        </Button>
                    </Rules>
                </FlexRight>
            </FlexBox>
        </SectionFiltersGrid>
    )
}
